<template>
  <flight-bookings-list :filters="query" :page-size="20" />
</template>

<script>
import FlightBookingsList from './List.vue'

export default {
  name: 'FlightBookingsArchive',
  components: { FlightBookingsList },
  props: {
    filters: { type: Object, default: () => ({}) }
  },
  computed: {
    query() {
      return { ...this.filters, category: 'archive', status_exclude: 'cancelled' }
    }
  }
}
</script>
